import { createSlice } from '@reduxjs/toolkit';
// import { validateNationalIdNumberFormat } from '../../library/national-id';

const initialState = {
    meta: {
        pageNumber: 1,
        pageSize: 20,
        itemTotal: 0
    },
    list: [],
    selectedCompany: {
        _id: undefined,
        accountManager: undefined
    },
    companyAdded: false,
    companyUpdated: false,
    companyRemoved: false,
};

const companiesSlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {
        getCompanies(state, action) {
            state.list = action.payload.companies;
            state.meta = action.payload.meta
        },
        viewCompany(state, action) {
            state.selectedCompany = action.payload;
        },
        addCompany(state, action) {
            state.companyAdded = true
        },
        updateCompany(state, action) {
            state.companyUpdated = true
        },
        removeCompany(state, action) {
            state.companyRemoved = true
        },
        reset: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const companiesActions = companiesSlice.actions;
export default companiesSlice;
